import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Input, Button, Row, Col, Breadcrumb, Select, Tag } from 'antd';
import 'antd/dist/antd.css';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getDirecteur, updateDirecteur, createDirecteur, reset } from './directeur.reducer';
import { IDirecteur } from 'app/shared/model/directeur.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';

export const DirecteurUpdate = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const users = useAppSelector(state => state.userManagement.users);
  const ecoleList = useAppSelector(state => state.ecole.entity);
  const directeur = useAppSelector(state => state.directeur.entity);
  const loading = useAppSelector(state => state.directeur.loading);
  const updating = useAppSelector(state => state.directeur.updating);
  const updateSuccess = useAppSelector(state => state.directeur.updateSuccess);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const isNotDirecteur = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR]));
  let selectedRole = AUTHORITIES.DIRECTEUR_ETUDE;

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/directeur/${currentEcole && currentEcole.id}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      dispatch(getEcole(props.match.params.ecoleid));
    } else {
      dispatch(getEcole(props.match.params.ecoleid));
      dispatch(getDirecteur(props.match.params.id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose(event);
    }
  }, [updateSuccess]);

  const handleRole = data => {
    selectedRole = data;
  };

  const saveEntity = values => {
    const entity = {
      ...directeur,
      ...values,
      ecoleId: props.match.params.ecoleid,
      directeurAuthority: selectedRole,
    };

    if (isNew) {
      dispatch(createDirecteur(entity));
    } else {
      dispatch(updateDirecteur(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...directeur,
          userId: directeur?.id,
        };
  const { match } = props;
  return (
    <div>
      {isNew ? (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/directeur/${currentEcole && currentEcole.id}`}>Directeurs</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/directeur/${currentEcole && currentEcole.id}`}>Directeurs</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${match.url}`}>Details</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      )}
      <Row className="justify-content-center">
        <Col span="12">
          {isNew ? (
            <h2 id="korischoolApp.directeur.home.createOrEditLabel" data-cy="DirecteurCreateHeading">
              <Translate contentKey="korischoolApp.directeur.home.createLabel">Create a Directeur</Translate>
            </h2>
          ) : (
            <h2 id="korischoolApp.directeur.home.createOrEditLabel" data-cy="DirecteurUpdateHeading">
              <Translate contentKey="korischoolApp.directeur.home.editLabel">Edit Directeur</Translate>
            </h2>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col span="12">
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            layout="vertical"
            size="large"
            initialValues={!isNew && directeur}
            onFinish={saveEntity}
          >
            <Form.Item label="Login" name="login" rules={[{ required: true }]}>
              <Input placeholder="Login" />
            </Form.Item>
            <Form.Item label="Prénom" name="firstName" rules={[{ required: true }]}>
              <Input placeholder="Prenom" />
            </Form.Item>
            <Form.Item label="Nom" name="lastName" rules={[{ required: true }]}>
              <Input placeholder="Nom" />
            </Form.Item>
            <Form.Item
              label="Téléphone"
              name="telephone"
              rules={[
                { required: true, message: 'Ce champ est requis' },
                {
                  pattern: /^\d{9}$/,
                  message: 'Ce champ doit contenir exactement 9 chiffres',
                },
              ]}
            >
              <Input
                placeholder="Téléphone"
                maxLength={9}
                inputMode="numeric"
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Form.Item label="E-mail" name="email" rules={[{ required: true, type: 'email', message: 'saisir un e-mail valide' }]}>
              <Input placeholder="E-mail" />
            </Form.Item>
            {isNew && isNotDirecteur && (
              <Form.Item label="Role">
                <Select placeholder="Role" style={{ width: '100%' }} allowClear onChange={handleRole} defaultValue={directeur.authorities}>
                  <Select.Option value="ROLE_DIRECTEUR">
                    <Tag color="gray">Directeur</Tag>
                  </Select.Option>
                  <Select.Option value="ROLE_DIRECTEUR_ETUDE">
                    <Tag color="gray">Directeur Etude</Tag>
                  </Select.Option>
                </Select>
              </Form.Item>
            )}
            <Form.Item>
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                data-cy="entityCreateSaveButton"
                htmlType="submit"
                id="save-entity"
              >
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default DirecteurUpdate;
